import CloseIcon from '../../../assets/icons/close.svg?react';
import { useState } from 'react';

const DeleteRoleModal = ({ role, onClose, onConfirm }) => {
  const [isPending, setIsPending] = useState(false);
  const handleConfirm = async () => {
    setIsPending(true);
    try {
      await onConfirm(role);
      onClose();
    } catch (error) {
      console.error('역할 삭제 실패:', error);
      alert('역할 삭제에 실패했습니다.');
    } finally {
      setIsPending(false);
    }
  };
  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header">
          <h3 className="text-h3 text-gray-900">역할 삭제</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content">
          <p className="text-b2-400 text-gray-700 my-10">역할을 삭제하시겠습니까?</p>
          <table className="gray-table">
            <tr>
              <th>역할명</th>
              <td>{role}</td>
            </tr>
          </table>
        </div>
        <div className="modal-footer">
          <button className="btn py-5 px-10 big-btn btn-primary flex-1" onClick={handleConfirm} disabled={isPending}>{isPending ? '삭제 중...' : '삭제'}</button>
          <button className="btn py-5 px-10 big-btn btn-style-5 flex-1" onClick={onClose}>취소</button>
        </div>
      </div>
    </div>
  )
}

export default DeleteRoleModal